import type { Address, Message } from './api';

/**
 * Recipients the server will use for a reply (shown read-only in the composer). `self` = the
 * user's own addresses (login address, identity replied as), left out of reply all.
 * Participants without an address (unresolvable EX, gx-16) are skipped.
 */
export function replyRecipients(message: Message, all: boolean, self: readonly string[] = []): { to: Address[]; cc: Address[] } {
  const usable = (list: readonly Address[]) => list.filter((a) => a.address !== '');
  const primary = usable(message.replyTo.length > 0 ? message.replyTo : [message.from]);
  if (!all) return { to: primary, cc: [] };
  const seen = new Set(self.map((s) => s.toLowerCase()));
  const unique = (addresses: readonly Address[]) =>
    usable(addresses).filter((a) => {
      const key = a.address.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  const to = unique([...primary, ...message.to]);
  return { to: to.length > 0 ? to : primary, cc: unique(message.cc) };
}
